module.exports = __webpack_public_path__ + "static/media/nuk-pro-back-sky.96828f5c.jpg";